import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import queryString from 'query-string';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
// import { getStripeChargeEvents } from '../../actions/StripeChargeEvent';
import { getAccounts } from '../../actions/Accounts';
import { downloadGroup } from '../../actions/Groups';
import ChangeTicketMenuTable from '../organisms/ChangeTicketMenuTable';
import SearchButton from '../../components/atoms/SearchButton';
import { getMenuOneToN } from '../../actions/GochiMenus';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonGroupRight: {
    textAlign: 'right'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      statuses: state.identities.statuses
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getMenuOneToN, getAccounts, downloadGroup },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('selected', 'setSelected', []),
  withState('page', 'setPage', 0),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('operatorName', 'setOperatorName', 0),
  withState('gochiType', 'setGochiType', 0),
  withState('resultMessage', 'setResultMessage', ''),
  withState('gochiBillId', 'setGochiBillId', ''),
  withState('firstMenuName', 'setFirstMenuName', ''),
  withState('firstPrice', 'setFirstPrice', ''),
  withState('firstCouponCount', 'setFirstCouponCount', ''),
  withState('menuName', 'setMenuName', ''),
  withState('price', 'setPrice', ''),
  withState('shopId', 'setShopId', ''),
  withState('groupId', 'setGroupId', ''),
  withState('gochiBillId', 'setGochiBillId', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      console.log(props);
      props.setPage(page);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      // this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
      //   this.props.checkSession(data);

      //   await this.props.actions
      //     .getGochis({
      //       page: this.props.page,
      //       limit: this.props.rowsPerPage
      //     })
      //     .then(gochiData => this.props.checkSession(gochiData));
      //   this.props.updateOpenTable(true);
      // });
      const getGochiBillId = queryString.parse(this.props.location.search)
        .gochiBillId
        ? queryString.parse(this.props.location.search).gochiBillId
        : '';
      if (getGochiBillId) {
        this.props.setGochiBillId(getGochiBillId);
      } else {
        this.props.setGochiBillId(null);
      }

      const getFirstMenuName = queryString.parse(this.props.location.search)
        .firstMenuName
        ? queryString.parse(this.props.location.search).firstMenuName
        : '';
      if (getFirstMenuName) {
        this.props.setFirstMenuName(getFirstMenuName);
      } else {
        this.props.setFirstMenuName(null);
      }

      const getFirstPrice = queryString.parse(this.props.location.search)
        .firstPrice
        ? queryString.parse(this.props.location.search).firstPrice
        : '';
      if (getFirstPrice) {
        this.props.setFirstPrice(getFirstPrice);
      } else {
        this.props.setFirstPrice(null);
      }

      const getFirstCouponCount = queryString.parse(this.props.location.search)
        .firstCouponCount
        ? queryString.parse(this.props.location.search).firstCouponCount
        : '';
      if (getFirstCouponCount) {
        this.props.setFirstCouponCount(getFirstCouponCount);
      } else {
        this.props.setFirstCouponCount(null);
      }

      const getShopId = queryString.parse(this.props.location.search).shopId
        ? queryString.parse(this.props.location.search).shopId
        : '';
      if (getGochiBillId) {
        this.props.setShopId(getShopId);
      } else {
        this.props.setShopId('');
      }

      const getGroupId = queryString.parse(this.props.location.search).groupId
        ? queryString.parse(this.props.location.search).groupId
        : '';
      if (getGochiBillId) {
        this.props.setGroupId(getGroupId);
      } else {
        this.props.setGroupId('');
      }
    }
  })
);

const Main = enhance(
  ({
    actions,
    checkSession,
    classes,
    handleChangePage,
    account,
    openDrawer,
    updateOpenDrawer,
    updateOpenTable,
    openTable,
    loading,
    openProgress,
    updateLoading,
    updateOpenProgress,
    page,
    resultMessage,
    menuName,
    setMenuName,
    price,
    setPrice,
    gochiBillId,
    firstMenuName,
    firstPrice,
    firstCouponCount,
    setPage,
    shopId,
    groupId
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      menuName,
      price,
      shopId,
      groupId,
      page,
      limit: limitNum
    };
    const searchAction = async () => {
      updateOpenTable(true);
      updateLoading(true);
      updateOpenProgress(true);
      await actions
        .getMenuOneToN(searchKey)
        .then(data => {
          checkSession(data);
          updateOpenProgress(false);
          updateLoading(false);
          updateOpenTable(true);
        })
        .catch(() => {
          updateOpenProgress(false);
          updateLoading(false);
        });
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            ごちID：
            {gochiBillId}
            を分割します。
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
            <div className={classes.searchForm}>
              <div>
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TextField
                    label="メニュー名"
                    type="search"
                    className={classes.textField}
                    margin="normal"
                    value={menuName}
                    onChange={e => {
                      setMenuName(e.target.value);
                      // setSearchSortKey('abc');
                    }}
                  />
                )}
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TextField
                    label="メニュー単価"
                    type="search"
                    className={classes.textField}
                    margin="normal"
                    value={price}
                    onChange={e => {
                      setPrice(e.target.value);
                      // setSearchSortKey('abc');
                    }}
                  />
                )}
              </div>
              <div className={classes.buttonLeft}>
                <SearchButton onClickAction={searchAction} />
              </div>
            </div>
          )}
          {openTable && (
            <ChangeTicketMenuTable
              searchKey={searchKey}
              roles={roles}
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
              progress={progress}
              gochiBillId={gochiBillId}
              firstMenuName={firstMenuName}
              firstPrice={firstPrice}
              firstCouponCount={firstCouponCount}
              setPage={setPage}
            />
          )}
        </Paper>
        <ProgressDialog
          openProgress={openProgress}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
